import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormText from '../../components/form/FormText/FormText';

const FormTextContainer = props =>
  <Field
    name={props.name}
    component={FormText}
    props={props}
  />
;

FormTextContainer.propTypes = {
  name: PropTypes.string
};

export default FormTextContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/FormTextContainer.js
 **/